import { render, staticRenderFns } from "./CertificationMiniProgramLog.vue?vue&type=template&id=9bae7fbc&scoped=true&"
import script from "./CertificationMiniProgramLog.vue?vue&type=script&lang=js&"
export * from "./CertificationMiniProgramLog.vue?vue&type=script&lang=js&"
import style0 from "./CertificationMiniProgramLog.vue?vue&type=style&index=0&id=9bae7fbc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bae7fbc",
  null
  
)

export default component.exports